// import echarts from "echarts";
export function loadChart(myChart, resultArr, nyear, bfData, czUnit) {
  myChart.clear();
  if (bfData[0].length > 0) {
    // 颜色设置
    myChart.setOption({
      color: [
        "#84bbff",
        "#ffa64e",
        "#F3B90F",
        "#F86464",
        "#34A8FF",
        "#FA9022",
        "#19DC7C",
        "#F0ED00",
        "#8C70F8",
        "#00EEF0",
        "#00acee",
        "#52cdd5",
        "#79d9f1",
        "#a7e7ff",
        "#c8efff"
      ],
      tooltip: {
        //鼠标滑过交叉点的提示样式，默认是黑色半透明状态
        // trigger: "axis",
        trigger: "item",
        formatter: "{a}年{b}月  ：{c}" + czUnit
        // axisPointer: {
        //   label: {
        //     //X轴坐标文字样式
        //     show: true,
        //     backgroundColor: "#fff",
        //     color: "#556677",
        //     borderColor: "rgba(0,0,0,0)",
        //     shadowColor: "rgba(0,0,0,0)",
        //     shadowOffsetY: 0,
        //   },
        //   lineStyle: {
        //     width: 0,
        //   },
        // },
        // backgroundColor: "#fff",
        // textStyle: {
        //   color: "#5c6c7c",
        // },
        // padding: [10, 10],
        // extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)",
      },
      legend: {
        //右上角线类型标记
        show: true,
        data: resultArr,
        top: "0",
        right: "5%"
        // top: "0",
        // right: "5%",
        // icon: "circle", //图标点样式
        // itemWidth: 6,
        // itemGap: 20,
        // textStyle: {
        //   fontSize: 12
        // }
      },
      grid: {
        top: 50,
        left: "4%",
        right: "4%",
        bottom: "4%",
        containLabel: true
      },
      //横坐标设置
      xAxis: {
        type: "category",
        boundaryGap: false, //坐标轴两边留白
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            // color: "#fff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          },
          margin: 10
          // rotate: 40
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false
        },
        axisLine: {
          show: false,
          //坐标轴轴线相关设置
          lineStyle: {
            color: "#02a7fd"
          }
        },
        splitLine: {
          //坐标轴在 grid 区域中的分隔线。
          show: false
        },
        data: nyear
      },
      //纵坐标设置
      yAxis: {
        name: czUnit, //Y轴坐标名称 or 单位
        nameTextStyle: {
          color: "#00cfff",
          fontSize: 13,
          // align: "left",
          padding: [0, 0, 5, 0]
        },
        splitLine: {
          lineStyle: {
            //grid 区域内横坐标的线样式 此时为虚线
            // type: "dashed",
            color: "#162d4e"
          }
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false
        },
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 1, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            color: "#00deff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          }
          //rotate:50,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#08aeef"
          }
        }
      },
      series: [
        {
          name: resultArr[0],
          type: "line",
          smooth: true, //是否平滑
          // symbolSize: 25,
          itemStyle: {
            color: "#fff",
            borderColor: "#84bbff"
          },
          lineStyle: {
            color: "#84bbff"
          },
          label: {
            show: false,
            position: "top",
            textStyle: {
              color: "#84bbff"
            }
          },
          // areaStyle: {
          //   color: "rgba(13,67,90,.7)",
          // },
          // itemStyle: {
          //   normal: {
          //     color: "#00A7FD",
          //     //交叉点的阴影样式
          //     lineStyle: {
          //       color: "#19B1FC",
          //       width: 3
          //     },
          //     areaStyle: {
          //       color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          //         {
          //           offset: 0,
          //           color: "rgba(248,137,64,0)"
          //         },
          //         {
          //           offset: 1,
          //           color: "rgba(0,167,253,0.35)"
          //         }
          //       ])
          //     }
          //   }
          // },
          symbol: "circle", //数据交叉点样式
          symbolSize: 8, //数据交叉点尺寸
          data: bfData[0]
          // markPoint: {
          // 	animationEasing: 'elasticOut',
          // 	animationDelay: function(idx) {
          // 		return idx * 200 + 1000
          // 	},
          // 	data: [
          // 		{
          // 			type: 'max',
          // 		},
          // 	],
          // },
        },
        {
          name: resultArr[1],
          type: "line",
          smooth: true, //是否平滑
          // symbolSize: 25,
          itemStyle: {
            color: "#fff",
            borderColor: "#ffa64e"
          },
          lineStyle: {
            color: "#ffa64e"
          },
          label: {
            show: false,
            position: "top",
            textStyle: {
              color: "#ffa64e"
            }
          },
          // areaStyle: {
          //   color: "rgba(204, 146, 82,.7)",
          // },
          // itemStyle: {
          //   normal: {
          //     color: "#00A7FD",
          //     //交叉点的阴影样式
          //     lineStyle: {
          //       color: "#19B1FC",
          //       width: 3
          //     },
          //     areaStyle: {
          //       color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          //         {
          //           offset: 0,
          //           color: "rgba(248,137,64,0)"
          //         },
          //         {
          //           offset: 1,
          //           color: "rgba(0,167,253,0.35)"
          //         }
          //       ])
          //     }
          //   }
          // },
          symbol: "circle", //数据交叉点样式
          symbolSize: 8, //数据交叉点尺寸
          data: bfData[1]
          // markPoint: {
          // 	animationEasing: 'elasticOut',
          // 	animationDelay: function(idx) {
          // 		return idx * 200 + 1000
          // 	},
          // 	data: [
          // 		{
          // 			type: 'max',
          // 		},
          // 	],
          // },
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
